import React from "react";
import { Filter, Calendar } from "lucide-react";

const RISK_LEVELS = ["All", "Low", "Medium", "High", "Critical"];
const SCREENING_TYPES = ["All", "Individual", "Corporate", "Director"];
const INDIA_SOURCES = [
  "MHA UAPA", "RBI Defaulters", "SEBI Debarred", "ED Press",
  "CBI Wanted", "MCA21", "SFIO Fraud", "NCLT Insolvency", "eCourts", "GSTN",
];

export function AdvancedFiltersBar({ filters, setFilters }) {
  const update = (key, value) => setFilters(prev => ({ ...prev, [key]: value }));

  return (
    <div data-testid="advanced-filters-bar" style={{
      background: "#0d1117", border: "1px solid #1e2530", borderRadius: "10px",
      padding: "14px 18px", marginBottom: "16px",
    }}>
      <div className="flex items-center gap-2 mb-3">
        <Filter style={{ width: "13px", height: "13px", color: "#475569" }} />
        <span style={{ fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "1px" }}>
          Advanced Filters
        </span>
      </div>

      <div className="flex flex-wrap items-end gap-4">
        {/* Screening Type */}
        <div>
          <label style={labelStyle}>Screening Type</label>
          <select value={filters.screeningType || "All"} onChange={e => update("screeningType", e.target.value)}
            data-testid="filter-screening-type" style={selectStyle}>
            {SCREENING_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>

        {/* Risk Level */}
        <div>
          <label style={labelStyle}>Risk Level</label>
          <select value={filters.riskLevel || "All"} onChange={e => update("riskLevel", e.target.value)}
            data-testid="filter-risk-level" style={selectStyle}>
            {RISK_LEVELS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>

        {/* Date From */}
        <div>
          <label style={labelStyle}>From</label>
          <input type="date" value={filters.dateFrom || ""} onChange={e => update("dateFrom", e.target.value)}
            data-testid="filter-date-from" style={{ ...selectStyle, colorScheme: "dark" }} />
        </div>

        {/* Date To */}
        <div>
          <label style={labelStyle}>To</label>
          <input type="date" value={filters.dateTo || ""} onChange={e => update("dateTo", e.target.value)}
            data-testid="filter-date-to" style={{ ...selectStyle, colorScheme: "dark" }} />
        </div>

        {/* Clear */}
        <button
          onClick={() => setFilters({ screeningType: "All", riskLevel: "All", dateFrom: "", dateTo: "", sources: [] })}
          data-testid="clear-filters"
          style={{
            background: "transparent", border: "1px solid #1e2530", borderRadius: "6px",
            padding: "7px 14px", cursor: "pointer", color: "#94a3b8", fontSize: "11px", fontWeight: 600,
            marginBottom: "1px",
          }}>
          Clear
        </button>
      </div>
    </div>
  );
}

const labelStyle = { fontSize: "9px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.5px" };
const selectStyle = {
  background: "#080c12", border: "1px solid #1e2530", borderRadius: "6px",
  padding: "7px 10px", color: "#f1f5f9", fontSize: "12px", outline: "none", minWidth: "120px",
};
